import React, { useLayoutEffect } from 'react'
import Error from 'components/shared/Error'
import Grid from '@material-ui/core/Grid'
import TileContainer from 'redux/containers/components/tiled-menu/TileContainer'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const LegislationTiledMenu = ({ folders, ...props }) => (
  <ResponseConsumer
    response={folders}
    skeleton='legislation-tiled-menu'
    content={() => <TiledMenu {...{ folders, ...props }} />}
  />
)

const TiledMenu = ({ folders, getUrl, category, cxNames, setIsLegTileMenuLoaded }) => {
  useLayoutEffect(() => {
    setIsLegTileMenuLoaded(true)
  }, [])

  return (
    <nav>
      {folders.length === 0
        ? <Error title='No content' />
        : (
          <Grid container spacing={2}>
            {folders.map((folder, index) => (
              <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
                <TileContainer
                  id={folder.name}
                  getUrl={getUrl({ name: folder.name })}
                  title={folder.name}
                  active
                  showInactive
                  hideInfo
                  category={category}
                  cxNames={cxNames}
                />
              </Grid>
            ))}
          </Grid>
          )}
    </nav>
  )
}

export default LegislationTiledMenu
